import React from 'react';
import { LifeAreaItemCard } from 'shared/components/ui/life-area-item-card';
import {
  SortableContainer,
  SortableContainerProps,
} from 'shared/components/ui/sortable-container';
import { DraggableOptions } from 'shared/types/draggable-types';
import { LifeArea } from 'shared/types/life-area';
import { lifeAreaOtherID } from 'shared/types/orderable-section';

export type LifeAreaCardProps = Omit<
  React.ComponentProps<typeof LifeAreaItemCard>,
  'lifeArea'
> & {
  lifeArea: LifeArea;
  hasDnd?: boolean;
  preventDnd?: boolean;
  children?: React.ReactNode;
};

const allDraggableOptions = Object.values(DraggableOptions);

export const LifeAreaCard: React.FC<LifeAreaCardProps> = ({
  lifeArea,
  hasDnd,
  preventDnd,
  children,
  ...rest
}) => {
  const Container = hasDnd ? SortableContainer : React.Fragment;
  const containerProps = (
    hasDnd
      ? {
          id: lifeArea.id,
          type: DraggableOptions.LifeArea,
          cantDrag: lifeArea.id === lifeAreaOtherID,
          cantInteractWithTypes: preventDnd
            ? allDraggableOptions
            : lifeArea.id === lifeAreaOtherID
              ? [DraggableOptions.LifeArea]
              : undefined,
        }
      : {}
  ) as SortableContainerProps;

  return (
    <Container {...containerProps}>
      <LifeAreaItemCard lifeArea={lifeArea} {...rest} />
      {children}
    </Container>
  );
};
